var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86418236,4.22408488 L1.23469564,2.59459816 C1.12206935,2.48197187 1.12206935,2.29985276 1.23469564,2.18842463 L1.50547799,1.91764228 C1.61810428,1.80501599 1.80022338,1.80501599 1.91165152,1.91764228 L3.06667004,3.0726608 L4.22168857,1.91764228 C4.33431486,1.80501599 4.51643396,1.80501599 4.6278621,1.91764228 L4.89864445,2.18842463 C5.01127074,2.30105092 5.01127074,2.48317002 4.89864445,2.59459816 L3.26915773,4.22408488 C3.15892775,4.33671116 2.97680864,4.33671116 2.86418236,4.22408488 L2.86418236,4.22408488 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDown);
export default __webpack_public_path__ + "static/media/angle-down.4ced96a6a304f767886687e64ebe5cbf.svg";
export { ForwardRef as ReactComponent };